const workflowTemplateFilters = {
  businessEntityId: null,
  typeId: null,
  clientId: null,
  isActive: null
}

export default () => Object.assign({}, workflowTemplateFilters)
